import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-booking-confirmation',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="container">
      <div class="row justify-center">
        <div class="col-xl-6 col-lg-8">
          <div class="py-90 px-50 lg:py-50 lg:px-20 bg-white rounded-4 border-light">
            <div class="row y-gap-20">
              <div class="col-12">
                <div class="text-center">
                  <div class="icon-check-circle text-60 text-green-2 mb-20"></div>
                  <h1 class="text-30 fw-600">Rezervasyon Tamamlandı!</h1>
                  <p class="text-light-1 mt-15">
                    Rezervasyonunuz başarıyla tamamlandı. Rezervasyon detaylarınız aşağıda yer almaktadır.
                  </p>
                </div>
              </div>

              <div class="col-12" *ngIf="pnrCode || productKey || roomKey">
                <div class="border-top-light pt-30 mt-30"> <div class="text-15 fw-500 mb-15">Rezervasyon Detayları:</div>
                  
                  <div class="row y-gap-10" *ngIf="pnrCode">
                    <div class="col-12">
                      <div class="d-flex justify-between">
                        <div class="text-light-1">PNR Kodu:</div>
                        <div class="text-18 fw-600 text-green-2">{{ pnrCode }}</div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="row y-gap-10" *ngIf="productKey">
                    <div class="col-12">
                      <div class="d-flex justify-between">
                        <div class="text-light-1">Ürün Anahtarı:</div>
                        <div class="text-15">{{ productKey | slice:0:20 }}...</div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="row y-gap-10" *ngIf="roomKey">
                    <div class="col-12">
                      <div class="d-flex justify-between">
                        <div class="text-light-1">Oda Anahtarı:</div>
                        <div class="text-15">{{ roomKey }}</div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="row y-gap-10" *ngIf="bookingResult?.bookingDetails">
                    <div class="col-12">
                      <div class="bg-blue-2 rounded-4 p-20 mt-15">
                        <div class="text-15 fw-500 mb-10">Rezervasyon Bilgileri:</div>
                        <div class="text-14 text-light-1">
                          Rezervasyon işleminiz başarıyla tamamlanmıştır. 
                          E-posta adresinize detaylı bilgiler gönderilmiştir.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="row x-gap-20 pt-30">
                  <div class="col-auto">
                    <button 
                      class="button h-50 px-24 -dark-1 bg-blue-1 text-white"
                      (click)="downloadTicket()">
                      Bileti İndir
                      <div class="icon-download ml-15"></div>
                    </button>
                  </div>
                  
                  <div class="col-auto">
                    <button 
                      class="button h-50 px-24 -blue-1 bg-blue-1-05 text-blue-1"
                      (click)="goBack()">
                      Geri Dön
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .container {
      min-height: 70vh;
      display: flex;
      align-items: center;
    }
  `]
})
export class BookingConfirmationComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  productKey: string | null = null;
  roomKey: string | null = null;
  pnrCode: string | null = null;
  bookingResult: any = null;

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.productKey = params['productKey'] || null;
      this.roomKey = params['roomKey'] || null;
      this.pnrCode = params['pnr'] || null;
    });

    // Navigation state'den booking sonucunu al
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      this.bookingResult = navigation.extras.state['bookingResult'];
    }
  }

  downloadTicket(): void {
    // Bu kısımda rezervasyon biletini indirme işlemi yapılabilir
    alert('Bilet indirme özelliği henüz hazır değil. Bu bir demo implementasyondur.');
  }

  goBack(): void {
    window.history.back();
  }
}
